import { useContext, useEffect, useRef, useState } from 'react';

import { PusherContext } from '~/domains/pusher/PusherContext';

import { PUSHER_EVENT } from '../constants';

type UsePusherChannelOptions = {
  channelName: string | null;
  onEvent: (payload: unknown) => void;
};

export const usePusherChannel = ({ channelName, onEvent }: UsePusherChannelOptions): boolean => {
  const { subscribeToChannel, unsubscribeFromChannel } = useContext(PusherContext);

  const [isSubscribed, setIsSubscribed] = useState(false);
  const onEventRef = useRef(onEvent);

  onEventRef.current = onEvent;

  useEffect(() => {
    if (!channelName) return undefined;

    const events = [
      { name: PUSHER_EVENT, callback: (payload: unknown) => onEventRef.current(payload) },
    ];

    subscribeToChannel(channelName, events);
    setIsSubscribed(true);

    return () => {
      unsubscribeFromChannel(channelName, events);
      setIsSubscribed(false);
    };
  }, [channelName, subscribeToChannel, unsubscribeFromChannel]);

  return isSubscribed;
};
